<app-header></app-header>
<div class="main_wrp" *ngIf="!sign_flag">
    <div class="sub_wrp">

        <div class="img_wrp">
            <img src="https://d37pbainmkhx6o.cloudfront.net/beto_paredes_nest/home/Beto_Logo.png" />
        </div>

        <div class="text_wrp">

            <form class="form_wrp" name="loginForm" [formGroup]="loginForm">

                <h1>COMMISSION AGREEMENT FOR THE BIOGENIX-MD PORTAL</h1>

                <p>This Commission Agreement ("Agreement") is made and entered into as of {{loginForm.value.date}}, by
                    and between
                    BiogenicMD, a joint venture managed by the Beto Paredes Family of Companies ("Company"), with a
                    principal business address at 2675 Titan Drive Rexburg, ID ,83440 and

                    <strong class="salesperson_name">
                        <mat-form-field class="textfirld_wrp">
                            <input matInput name="rep_name" placeholder="Associate Director" formControlName="rep_name"
                                required class="textfirld_subwrp" (input)="runing($event)"
                                [value]="loginForm.value.rep_name" />
                        </mat-form-field>
                        <mat-error *ngIf="errors?.rep_name">Rep name is required</mat-error>
                    </strong>
                    ("Representative"), residing at {{userData.location}}.

                </p>

                <h3>1. Appointment and Acceptance</h3>
                <p> The Company hereby appoints the Representative as an independent contractor to promote BiogenicMD by
                    signing up physicians to use its online portal for ordering nutraceuticals and peptides. The
                    Representative accepts this appointment and agrees to solely focus on physician sign-ups, while the
                    Company manages all other aspects of the service and product delivery.
                </p>

                <h3>2. Commission</h3>
                <p> The Representative will earn a commission of 10% of the gross net, calculated as the profit after a
                    revenue share with the healthcare provider. Healthcare providers receive a 50% commission on the
                    gross sale of products, which are directly shipped to their patients.</p>

                <h3>3. Responsibilities of the Representative</h3>
                <p> The Representative is responsible for:</p>
                <ul class="sale_commission">
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Presenting the BiogenicMD opportunity to potential
                            physicians.</h5>
                    </li>
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Ensuring successful sign-up of physicians through the
                            BiogenicMD online portal, which incurs no start-up cost for the physician.</h5>
                    </li>
                </ul>


                <h3>4. Company Responsibilities</h3>
                <p> The Company will manage all operations related to orders through the BiogenicMD portal, including
                    but not limited to:</p>
                <ul class="sale_commission">
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Streamlined Ordering: Facilitating easy order of
                            nutraceuticals and peptides without inventory requirements.</h5>
                    </li>
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Efficient Payment Processing: Managing patient order
                            payments via credit cards through the BiogenicMD Portal, ensuring timely payment to
                            physicians.</h5>
                    </li>
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Continued Patient Engagement: Providing continuous
                            access to educational materials, order tracking, and support to enhance patient health
                            outcomes and satisfaction.</h5>
                    </li>
                </ul>


                <h3>5. Payment Terms</h3>
                <p>The Company will pay the Representative all earned commissions on a monthly basis, net 7 days from
                    the date of officially received payments.</p>

                <h3>6. Term and Termination</h3>
                <p>This Agreement shall commence on the date hereof and continue until terminated by either party with
                    thirty (30) days written notice. Either party may terminate this Agreement without cause upon
                    written notice to the other party.
                </p>

                <h3>7. Independent Contractor</h3>
                <p> The Representative is an independent contractor and shall have no authority to bind the Company in
                    any manner. This Agreement does not create an employer-employee relationship between the Company and
                    the Representative.</p>

                <h3>8. Confidentiality</h3>
                <p>The Representative agrees to keep all proprietary information, including but not limited to customer
                    lists, trade secrets, and pricing information, confidential during and after the term of this
                    Agreement.
                <h3>9. Non-Disclosure and Non-Circumvention</h3>
                <p> 9.1 Non-Disclosure: The Representative acknowledges that in the course of performing duties under
                    this Agreement, they will have access to and be entrusted with Confidential Information (as defined
                    in Section 8) belonging to the Company, its affiliates, and its clients (including physicians using
                    the portal). The Representative agrees to hold such Confidential Information in strict confidence
                    and not to disclose it to any third party, nor use it for any purpose other than the performance of
                    duties under this Agreement, both during the term of this Agreement and perpetually thereafter.</p>
                <p>9.2 Non-Circumvention: The Representative agrees that during the term of this Agreement and for a
                    period of two (2) years following its termination, the Representative shall not, directly or
                    indirectly, circumvent, attempt to circumvent, avoid, or bypass the Company in any transaction
                    involving any physician or healthcare practice introduced to the Representative by the Company or
                    signed up by the Representative under this Agreement. Specifically, the Representative shall not:
                </p>
                <ul class="sale_commission">
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Initiate contact or negotiate with such physicians or
                            practices concerning services or products similar to or competitive with those offered
                            through the Biogenix-MD portal, except through the Company as contemplated by this
                            Agreement.</h5>
                    </li>
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Divert or attempt to divert any business opportunity
                            related to the Biogenix-MD portal or similar services/products away from the Company
                            involving such physicians or practices.</h5>
                    </li>
                    <li class="sale_commission_prodict">
                        <h5 class="sale_commission_prodict_header">Utilize Confidential Information to solicit such
                            physicians or practices for any purpose outside the scope of this Agreement or detrimental
                            to the Company's business interests.
                            The intent of this clause is to protect the Company's business relationships and ensure that
                            the Representative does not leverage relationships or information gained through this
                            Agreement to bypass the Company and avoid the commission structure herein.</h5>
                    </li>
                </ul>
                <h3>10. Arbitration</h3>
                <p>Any disputes arising under this Agreement shall be resolved through binding arbitration in accordance
                    with the rules of the American Arbitration Association, and any such arbitration shall take place in
                    Atlanta, Georgia.</p>

                <h3>11. Governing Law </h3>
                <p>This Agreement shall be governed by and construed in accordance with the laws of the state of
                    Georgia.</p>


                <p>IN WITNESS WHEREOF, the parties hereto have executed this Commission Agreement as of the day and year
                    first above written.</p>



                <div class="footer_main_wrp">
                    <div class="footer_sub_wrp">
                        <h3 class="assciate_wrp">Associate Director:</h3>
                        <p>Signature :<strong class="signature_wrpper">
                                <mat-form-field class="textfirld_wrp signature_txt_wrppr">
                                    <input matInput name="signature" formControlName="signature"
                                        autocomplete="new-password" required
                                        [ngClass]="sign_flag ? 'textfirld_subwrp' : 'textfirld_subwrp'"
                                        (keydown)="runing($event)" [readonly]="filedstatus" />
                                </mat-form-field>
                                <mat-error class="contact_error" *ngIf="errors?.signature">Signature is
                                    required</mat-error>
                            </strong>
                        </p>

                        <p>Full Name: <strong>
                                <mat-form-field class="textfirld_wrp">
                                    <input matInput name="rep_name" formControlName="rep_name"
                                        [value]="loginForm.value.rep_name" class="" readonly="true"
                                        (input)="runing($event)" />
                                </mat-form-field>
                                <mat-error class="contact_error" *ngIf="errors?.rep_name">Rep name is
                                    required</mat-error>
                            </strong>
                        </p>


                        <p class="value_wrp">Date: <strong>{{ today }}</strong></p>

                    </div>

                    <div class="sign_wrp">

                        <div class="sign_wrp_beto">
                            <h3>By:</h3>
                            <div class="sign_wrp_beto_img"> <img
                                    src="https://all-frontend-assets.s3.amazonaws.com/betoparedes-v3/beto_signature.webp" />
                            </div>
                        </div>

                        <p> Full Name:<strong>
                                <mat-form-field class="textfirld_wrp">
                                    <input matInput name="beto_name" formControlName="beto_name" required class=""
                                        (input)="runing($event)" [disabled]="true" />
                                </mat-form-field>
                                <!-- <mat-error *ngIf="errors?.rep_name">Rep name is required</mat-error> -->
                            </strong>
                        </p>

                        <p>President, Beto Paredes Family of Companies</p>

                    </div>

                </div>

                <button [ngClass]=" contractData ? 'contract_btn_disable' : 'contract_button_wrp' "
                    (click)="contractSubmit()" [disabled]="contractData ? true : false">
                    Submit
                </button>

                <mat-progress-bar *ngIf="loader" mode="indeterminate" class="loader_wrp"></mat-progress-bar>

            </form>

        </div>
    </div>
</div>



<!-- -------------------------------------for download--------------------------------- -->

<div id="contract_form" *ngIf="sign_flag">
    <mat-progress-bar *ngIf="loader" mode="indeterminate" class="loader_wrp"></mat-progress-bar>

    <div *ngIf="extractedContent; else noContract" class="main_wrp" style="padding: 30px;">
        <div class="contract_button_wraper">
            <button class="printPageButton" matTooltip="Download Contract Form" (click)="clickPrint()">
                <i class="fa-solid fa-arrow-down" aria-hidden="true"></i>
            </button>

            <button class="printPageButton" matTooltip="Get Download Link in Mail" (click)="emailsend()">
                <i class="fa-solid fa-envelope-open-text" aria-hidden="true"></i>
            </button>
        </div>

        <div [innerHTML]="extractedContent"></div>
    </div>

    <ng-template #noContract class="no-data-container">
        <div class="no-contract">
            <div class="inner-no-contract">
                <p>Oops!</p>
                <p>Contract Not Generated Yet, Please Come Some Time Letter</p>
            </div>
        </div>
    </ng-template>
</div>


<!-- -------------------------------------for download--------------------------------- -->